// extracted by mini-css-extract-plugin
export default {"box":"Pagebottom_box__WbqUu"};